import { Mail } from "lucide-react";
import { useTheme } from "@/hooks/useThemePreset";
import { useTranslation } from "@/hooks/useTranslation";
import { RELEVE_CONTACT_EMAIL } from "@/lib/brand";
import { LEGAL_DOCUMENT_URLS } from "@/lib/legalDocuments";

export function Footer() {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();
  const { t } = useTranslation("legal");

  return (
    <footer className="border-footer-border bg-footer text-footer-foreground w-full">
      <div className="px-6 py-3">
        <div className="flex flex-col md:flex-row items-center justify-between gap-2 text-sm">
          <div className="flex items-center gap-2">
            <img src={theme.logos.long} alt="Relevé" className="h-7 w-auto object-contain" />
            <span>© {currentYear} Relevé. All rights reserved.</span>
          </div>
          <div className="flex items-center gap-4">
            <a
              href={LEGAL_DOCUMENT_URLS["terms-of-service"]}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              {t("footer.terms")}
            </a>
            <a
              href={LEGAL_DOCUMENT_URLS["privacy-policy"]}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              {t("footer.privacy")}
            </a>
            <span className="flex items-center gap-2">
              <Mail className="h-3 w-3" />
              <a
                href={`mailto:${RELEVE_CONTACT_EMAIL}`}
                className="hover:opacity-80 transition-opacity"
              >
                {RELEVE_CONTACT_EMAIL}
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
